import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { VideoGallery } from './components/VideoGallery';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <VideoGallery />
        <Team />
        <Testimonials />
        <Services />
        <Gallery />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
